<template>
    <sidebar :data="data"
             :logo-url="urlGenerator('/')"
             :logo-src="resolvedLogoSrc"
             :logo-icon-src="resolvedLogoIconSrc"
             :company-name="configData.company_name"
    />

</template>

<script>
import {urlGenerator} from "../../../Helpers/AxiosHelper";
import { AuthMixin } from "../Auth/Mixins/AuthMixin";
import AppFunction from "../../../../core/helpers/app/AppFunction";

export default {
    name: 'DashboardSidebar',
    mixins: [AuthMixin],
    props: {
        data: {
            required: true
        },
        logo: {
            type: String,
        },
        logoIcon: {
            type: String,
        }
    },
    data() {
        return {
            urlGenerator
        }
    },
    computed: {
        resolvedLogoSrc() {
            if (this.logo) {
                return urlGenerator(this.logo);
            }

            return AppFunction.getAppUrl('logo_format_white.png');
        },
        resolvedLogoIconSrc() {
            return AppFunction.getAppUrl('images/favicon.png');
        }
    }
}
</script>
